<!--=============================
=            APPCARD            =
==============================-->
<template>
  <v-col xs12 md12 lg12 sm12>
    <v-card class="card ma-1" :dark="appConfig.dark">
      <v-list-item three-line flat dense card>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1 text-capitalize font-weight-medium">
            <slot name="card-header"></slot>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions justify center>
        <div class="card-body pa-3 subtitle-2">
          <slot name="card-body"></slot>
        </div>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
<script>
export default {
  name: "base-card",
  props: {
    title: {
      type: String,
      default: ""
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    contentBg: {
      type: String,
      default: "white"
    }
  }
};
</script>
<!--====  End of APPCARD  ====-->
